// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAdnj8Y2mMZOyAvq4OMcjbW8ZrF5YMn-v8",
  authDomain: "snk-music-store.firebaseapp.com",
  projectId: "snk-music-store",
  storageBucket: "snk-music-store.appspot.com",
  messagingSenderId: "178595991174",
  appId: "1:178595991174:web:de277205359e494dd5cb07",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export default firebaseConfig;
